import { Link } from 'react-router-dom'
import type { AdminUserWatchlist } from '../../services/admin'

interface AdminUserWatchlistSectionProps {
  userId: number
  watchlist: AdminUserWatchlist
}

const AdminUserWatchlistSection: React.FC<AdminUserWatchlistSectionProps> = ({
  userId,
  watchlist,
}) => {
  const { listCount, itemCount, lists, uncategorized } = watchlist

  if (listCount === 0 && itemCount === 0) {
    return <p className="text-xs text-ink-400">Ingen watchlist-emner endnu.</p>
  }

  return (
    <div className="space-y-2">
      <p className="text-xs text-ink">
        {listCount} {listCount === 1 ? 'liste' : 'lister'} · {itemCount}{' '}
        {itemCount === 1 ? 'emne' : 'emner'}
      </p>

      <ul className="space-y-1">
        {lists.map((list) => (
          <li key={list.id}>
            <Link
              to={`/account/admin/brugere/${userId}/watchlist/lister/${list.id}`}
              className="flex items-center gap-2 rounded-sm px-2 py-1.5 text-xs text-ink hover:bg-paper-200/50"
            >
              <span className="min-w-0 flex-1 truncate" title={list.name}>
                {list.name}
              </span>
              <span className="shrink-0 tabular-nums text-ink-500">{list.items.length}</span>
            </Link>
          </li>
        ))}
        {uncategorized.length > 0 ? (
          <li>
            <Link
              to={`/account/admin/brugere/${userId}/watchlist/uncategorized`}
              className="flex items-center gap-2 rounded-sm px-2 py-1.5 text-xs text-ink-500 hover:bg-paper-200/50"
            >
              <span className="min-w-0 flex-1 truncate" title="Uden liste">
                Uden liste
              </span>
              <span className="shrink-0 tabular-nums">{uncategorized.length}</span>
            </Link>
          </li>
        ) : null}
      </ul>
    </div>
  )
}

export default AdminUserWatchlistSection
